module.exports = __webpack_public_path__ + "media/images/s2ep4-cindy-9a00eab5c3d18e806b37aa96d3cfff74.png";